import { CheckCircle, Send, XCircle } from 'lucide-react';
import { Button } from '@/shared/ui/Button';

interface AppointmentBulkBarProps {
  selectedCount: number;
  maxSelection?: number;
  onMarkConfirmed: () => void;
  onSendReminder: () => void;
  onCancel: () => void;
  isProcessing?: boolean;
}

export function AppointmentBulkBar({
  selectedCount,
  maxSelection = 25,
  onMarkConfirmed,
  onSendReminder,
  onCancel,
  isProcessing,
}: AppointmentBulkBarProps) {
  if (selectedCount === 0) return null;

  const isOverLimit = selectedCount > maxSelection;

  return (
    <div className="flex items-center gap-3 rounded-xl2 border border-brand-200 bg-brand-50 px-4 py-3">
      <span className="text-sm font-semibold text-brand-700">
        {selectedCount} selected
        {isOverLimit && (
          <span className="ml-1 font-normal text-amber-600">
            (select up to {maxSelection})
          </span>
        )}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          onClick={onMarkConfirmed}
          disabled={isOverLimit || isProcessing}
        >
          <CheckCircle className="size-3.5" />
          Confirm
        </Button>
        <Button
          variant="secondary"
          size="sm"
          onClick={onSendReminder}
          disabled={isOverLimit || isProcessing}
        >
          <Send className="size-3.5" />
          Remind
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onCancel}
          disabled={isOverLimit || isProcessing}
          className="text-coral-600 hover:bg-coral-50"
        >
          <XCircle className="size-3.5" />
          Cancel
        </Button>
      </div>
    </div>
  );
}
